import { Component, OnDestroy, OnInit } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { filterNullOrUndefined } from "src/app/@operators/filter-null-or-undefined";
import { CityDto, ProvinceDto } from "src/app/api/models";
import { AppState, getState } from "src/app/state/app.state";
import { resetProvince } from "../../province/state/province.actions";
import { setTitle } from "../../title/state/title.actions";
import { resetCurrentCity, setSelectedCity, setSelectedProvince } from "../../transaction-info/state/transaction-info.actions";
import { loadCitysByProvince, resetCity } from "../state/city.actions";
import { getCityListCurrentProvince } from "../state/city.selectors";

@Component({
    selector: "app-city",
    templateUrl: "./city.component.html",
    styleUrls: ["./city.component.scss"],
    standalone: false
})
export class CityComponent implements OnInit,OnDestroy {
	public citys$: Observable<CityDto[]> = this.store.pipe(select(getCityListCurrentProvince)).pipe(filterNullOrUndefined());
	private selectedProvince: ProvinceDto = undefined;
	public properyToDisplay = "textEN";
	public properyToDisplay2 = "postalCode";
	private subs: Subscription[] = [];

	constructor(private store: Store<AppState>) {
		this.subs.push(
			getState(this.store).subscribe(state => {
				this.selectedProvince = state.transactionInfo.selectedProvince;
				this.properyToDisplay = "text" + state.transactionInfo.selectedLanguage.languageCode;
			})
		);
	}

	ngOnInit(): void {
		this.store.dispatch(
			setTitle({
				data: "TITLE_SELECT_CITY",
				data2: "TITLE_SELECT_CITY_INFO",
			})
		);

		this.store.dispatch(loadCitysByProvince({ provinceId: this.selectedProvince?.provinceId }));

		this.subs.push(
			this.citys$.subscribe((cities) => {
				if (cities.length === 1) {
					this.store.dispatch(setSelectedCity({ data: cities[0] }));
				}
			})
		);
	}

	ngOnDestroy(): void {
		this.subs.forEach((_) => _.unsubscribe());
	}

	onClickRetour() {
		this.store.dispatch(resetCity());
		this.store.dispatch(resetCurrentCity());
		this.store.dispatch(resetProvince());
		this.store.dispatch(setSelectedProvince(undefined));
	}

	public onClickCity(city: CityDto) {
		this.store.dispatch(setSelectedCity({ data: city }));
	}
}
